
import { contacts, request, steps } from '@/store/case'
import { appConfiguration } from '@/store/configuration'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  setup() {
    const projectManager = computed(() => contacts.value?.projectManager)

    return {
      ...appConfiguration.value?.content,
      steps,
      request,
      projectManager
    }
  }
})
